import axios from "axios";
export default {
  namespaced: true,
    state: {
        accessToken: null,
        userInfo: {},
    },
    getters: {
        accessToken: (state) => {
            return state.accessToken;
        },
        userInfo: (state) =>{
            return state.userInfo;
        }
    },
    mutations: {
        storeAccessToken(state, accessToken) {
            state.accessToken = accessToken;
        },
        storeUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
    },
    actions: {
        storeToken({ commit, dispatch }, data) {
            return new Promise((resolve, reject) => {
                localStorage.setItem("accessToken", data.token);
                // localStorage.setItem("userInfo", data.name);
                commit("storeAccessToken", data.token);
                commit("storeUserInfo", data);
                const jsonData = JSON.stringify(data);
                localStorage.setItem("userInfo", jsonData);
                axios.defaults.headers.common["Authorization"] =
                    "Bearer " + data.token;
                resolve();
            });
        },
        userLogout({ commit }) {
            return new Promise((resolve, reject) => {
                localStorage.clear();
                commit("storeAccessToken", null);
                axios.defaults.headers.common["Authorization"] = "";
                resolve();
            });
        },
    },
};

